import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { Eyebrow, Reveal } from "./Brand";
import { FAQ, CITIES } from "../../lib/data";

export const Coverage = () => (
  <section data-testid="coverage-section" className="relative py-24 lg:py-32 border-y border-white/5 bg-[#0B0B11] overflow-hidden">
    <div className="max-w-[1400px] mx-auto px-5 lg:px-10">
      <Reveal>
        <Eyebrow>Onde atendemos</Eyebrow>
        <p className="mt-6 font-display font-black uppercase text-white leading-[0.95]" style={{ fontSize: "clamp(2.2rem, 7vw, 6.5rem)" }}>
          Todo o <span className="text-gold-grad">Espírito</span><br /><span className="text-gold-grad">Santo.</span>
        </p>
      </Reveal>
      <Reveal delay={0.1} className="mt-12 grid lg:grid-cols-2 gap-10 items-end">
        <div className="flex flex-wrap gap-2">
          {CITIES.map((c) => (
            <span key={c} className="rounded-full border border-[#FFD200]/40 text-[#FFD200] px-4 py-2 text-sm">{c}</span>
          ))}
        </div>
        <p className="text-zinc-300 text-base md:text-lg">Valores dos pacotes válidos para os municípios da Grande Vitória. Para as demais cidades do ES, consulte o valor do deslocamento.</p>
      </Reveal>
    </div>
  </section>
);

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="relative py-28 lg:py-40">
    <div className="max-w-[1400px] mx-auto px-5 lg:px-10 grid lg:grid-cols-12 gap-12">
      <Reveal className="lg:col-span-4">
        <Eyebrow>Dúvidas frequentes</Eyebrow>
        <h2 className="mt-6 font-display font-black uppercase text-white text-4xl md:text-5xl leading-[1]">Perguntou,<br /><span className="text-red-grad">pegou.</span></h2>
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-8">
        <Accordion type="single" collapsible className="border-t border-white/10">
          {FAQ.map((f, i) => (
            <AccordionItem key={f.q} value={`f${i}`} className="border-b border-white/10" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="py-7 text-left font-display text-lg md:text-xl font-bold text-white hover:no-underline hover:text-[#FFD200] transition-colors">{f.q}</AccordionTrigger>
              <AccordionContent className="text-zinc-300 text-base leading-relaxed pb-7 max-w-2xl">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
